<script setup lang="ts">
  import {
    DrawerRoot,
    useForwardPropsEmits,
    type DrawerRootEmits,
    type DrawerRootProps,
  } from "reka-ui"
  import { provide, ref } from "vue"

  import { sheetSwipeDirectionKey } from "."

  const props = defineProps<DrawerRootProps>()
  const emits = defineEmits<DrawerRootEmits>()

  const forwarded = useForwardPropsEmits(props, emits)

  const swipeDirection = ref<DrawerRootProps["swipeDirection"]>()
  provide(sheetSwipeDirectionKey, swipeDirection)
</script>

<template>
  <DrawerRoot
    v-bind="forwarded"
    :swipe-direction="props.swipeDirection ?? swipeDirection"
  >
    <slot />
  </DrawerRoot>
</template>
